import { render } from "./EmailVerificationModal.vue?vue&type=template&id=d58e34d2&scoped=true"
import script from "./EmailVerificationModal.vue?vue&type=script&lang=js"
export * from "./EmailVerificationModal.vue?vue&type=script&lang=js"

import "../../../assets/css/Modals/AuthenticationModals/PhoneVerificationModal.css?vue&type=style&index=0&id=d58e34d2&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d58e34d2"]])

export default __exports__